import { render, staticRenderFns } from "./LenonResponsive.vue?vue&type=template&id=50bc4bed&scoped=true&"
import script from "./LenonResponsive.vue?vue&type=script&lang=js&"
export * from "./LenonResponsive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bc4bed",
  null
  
)

export default component.exports